import { useFeatureFlagByNameKey } from "../useFeatureFlagByNameKey";
import { KNOWLEDGE_HUB_FEATURE_NAME_KEY } from "./constants";
/**
 *
 * @deprecated Use useFeatureFlag instead. By example: `useFeatureFlag('KNOWLEDGE_HUB', 'V5')`
 */
function useKnowledgeHubFeature(organizationId) {
  var skip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var _useFeatureFlagByName = useFeatureFlagByNameKey({
      nameKey: KNOWLEDGE_HUB_FEATURE_NAME_KEY,
      organizationId: organizationId,
      skip: organizationId === undefined || skip
    }),
    loading = _useFeatureFlagByName.loading,
    error = _useFeatureFlagByName.error,
    activatedFlag = _useFeatureFlagByName.activatedFlag;
  return {
    activated: activatedFlag,
    loading: loading,
    error: error
  };
}
export default useKnowledgeHubFeature;